/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {LettersAvatarComponent as ɵa} from './src/app/modules/letters-avatar/letters-avatar.component';